export default __webpack_public_path__ + "static/media/T840MANA2.14741127.pdf";